import { GITHUB_TOKEN_TYPES } from '@linearb/linjs-common';
import { GIT_PROVIDERS } from 'common/constants/constants';
import { useEffect, useMemo, useState } from 'react';
import useIsTokenTypeSelectionEnabled from './useIsTokenTypeSelectionEnabled';

const mapProviderToTokenTypes = {
  //Each provider config should contain: {defaultValue, options: [{name, value}]}
  [GIT_PROVIDERS.GITHUB]: {
    defaultValue: GITHUB_TOKEN_TYPES.CLASSIC,
    options: [
      { name: 'Classic Token', value: GITHUB_TOKEN_TYPES.CLASSIC },
      { name: 'Fine Grained Token', value: GITHUB_TOKEN_TYPES.FINE_GRAINED }
    ]
  }
};

const useTokenTypes = ({ providerName } = {}) => {
  const providerId = GIT_PROVIDERS[providerName?.toUpperCase()];

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const isTokenTypeSelectionEnabled = useIsTokenTypeSelectionEnabled({
    providerId
  });

  const isEnabled = useMemo(
    () => options.length > 0 && !!selected,
    [options.length, selected]
  );

  const selectedOption = useMemo(
    () => options.find(option => option.value === selected),
    [selected]
  );

  const initTokenTypes = () => {
    const providerTokenTypes = mapProviderToTokenTypes[providerId];
    if (!providerTokenTypes || !providerId) return;

    const { options, defaultValue } = providerTokenTypes || {};
    if (!options || !defaultValue) return;

    setOptions(options);
    setSelected(defaultValue);
  };

  useEffect(() => {
    if (isTokenTypeSelectionEnabled) initTokenTypes();
  }, [providerId, isTokenTypeSelectionEnabled]);

  return {
    isEnabled,
    options,
    selected,
    setSelected,
    selectedOption
  };
};

export default useTokenTypes;
